import { reduxKey } from './constants';
import { createSelector } from 'reselect';
const emptyQueue = []; // here so that memoization doesn't break
function getNotificationState(state) {
    return state[reduxKey] || {
        default: []
    };
}
export const getNotificationQueue = createSelector(getNotificationState, (_, queue)=>queue !== null && queue !== void 0 ? queue : 'default', (state, queue)=>{
    var _state_queue;
    return (_state_queue = state[queue]) !== null && _state_queue !== void 0 ? _state_queue : emptyQueue;
});
export const getTopNotification = createSelector(getNotificationState, (_, queue)=>queue !== null && queue !== void 0 ? queue : 'default', (state, queue)=>{
    return state[queue][0];
});

//# sourceMappingURL=selectors.js.map